import React from 'react';


export const SmallCloseIcon:React.FC = () => {
  return (
<svg width="23" height="22" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="m10.1 12-4.6 4.6L6.9 18l4.8-4.8 4.8 4.8 1.4-1.4-4.6-4.6 4.6-4.6L16.5 6l-4.8 4.8L6.9 6 5.5 7.4l4.6 4.6z" fill="#122442"/>
</svg>

  )
}